import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Regions} from './regions.model';
import * as RegionsActions from './regions.actions';

export const regionsesFeatureKey = 'regionses';

export interface State extends EntityState<Regions> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Regions> = createEntityAdapter<Regions>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(RegionsActions.addRegions,
    (state, action) => adapter.addOne(action.regions, state)
  ),
  on(RegionsActions.upsertRegions,
    (state, action) => adapter.upsertOne(action.regions, state)
  ),
  on(RegionsActions.addRegionss,
    (state, action) => adapter.addMany(action.regionss, state)
  ),
  on(RegionsActions.upsertRegionss,
    (state, action) => adapter.upsertMany(action.regionss, state)
  ),
  on(RegionsActions.updateRegions,
    (state, action) => adapter.updateOne(action.regions, state)
  ),
  on(RegionsActions.updateRegionss,
    (state, action) => adapter.updateMany(action.regionss, state)
  ),
  on(RegionsActions.deleteRegions,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(RegionsActions.deleteRegionss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(RegionsActions.loadRegionss,
    (state, action) => adapter.setAll(action.regionss, state)
  ),
  on(RegionsActions.clearRegionss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
